import * as React from "react";
import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";

import { RootState } from "../../state";
import { companySelector, similarCompaniesSelector } from "../selectors";
import { Company } from "../entities";
import SimilarCompaniesSection from "./SimilarCompaniesSection";
import { loadSimilarCompaniesWorker } from "../actions";

interface MappedProps {
  company?: Company;
  similarCompanies: Company[];
}

interface MappedActions {
  loadSimilarCompaniesWorker: ((company: Company) => void);
}

type Props = MappedProps & MappedActions;

class SimilarCompaniesSectionContainer extends React.Component<Props> {
  public componentDidMount() {
    const { company, loadSimilarCompaniesWorker } = this.props;
    if (!company) {
      return;
    }

    loadSimilarCompaniesWorker(company);
  }

  public render() {
    const { similarCompanies } = this.props;

    return <SimilarCompaniesSection similarCompanies={similarCompanies} />;
  }
}

function mapStateToProps(state: RootState): MappedProps {
  const company = companySelector(state);
  const similarCompanies = similarCompaniesSelector(state);
  return { company, similarCompanies };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>): MappedActions {
  return bindActionCreators(
    {
      loadSimilarCompaniesWorker,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SimilarCompaniesSectionContainer);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/SimilarCompaniesSectionContainer.tsx